import React from 'react';
import { Skeleton, Card, Layout } from 'antd';
import { BrowserView, MobileView } from 'react-device-detect';
import '../styles.css';

const { Content } = Layout;

const LoadingState = () => (
  <>
    <BrowserView>
      <Layout className="public-recipe-layout">
        <Content className="public-recipe-content">
          <Card className="recipe-card">
            <Skeleton active paragraph={{ rows: 2 }} />
            <div style={{
              width: '100%',
              height: '400px',
              marginTop: '16px',
              marginBottom: '16px'
            }}>
              <Skeleton.Image style={{ width: '100%', height: '100%' }} active />
            </div>
            <Skeleton active paragraph={{ rows: 6 }} style={{ marginTop: '24px' }} />
          </Card>
        </Content>
      </Layout>
    </BrowserView>
    <MobileView>
      <div className="public-recipe-mobile">
        <Card style={{ margin: '12px', borderRadius: '8px' }}>
          <Skeleton active paragraph={{ rows: 2 }} />
          <div style={{
            width: '100%',
            height: '300px',
            marginTop: '16px',
            marginBottom: '16px'
          }}>
            <Skeleton.Image style={{ width: '100%', height: '100%' }} active />
          </div>
          <Skeleton active paragraph={{ rows: 6 }} style={{ marginTop: '24px' }} />
        </Card>
      </div>
    </MobileView>
  </>
);

export default LoadingState;
